module.exports = __webpack_public_path__ + "static/media/signUp_graphic.9685e448.png";